import { RHFTextField } from "@components/hook-form";
import { LockedButton } from "@components/lockedButtons/LockedButton";
import { Box, Card, Stack, Typography } from "@mui/material";
import { useCommonStyles } from "@pages/ManualDocumentV2/hooks/useCommonStyles";
import { IDocumentsAddForm } from "../../../../@types/manualDocument/documentSeriesTypes";

export const DocumentsAddForm = ({
  handleSubmit,
  onSubmit,
  translate,
  isLoading,
  isWriteDisabled,
}: IDocumentsAddForm) => {
  const { inputContainer } = useCommonStyles();
  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ flexShrink: 0 }}>
      <Card sx={inputContainer}>
        <Box sx={{ mb: 1 }}>
          <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 0.5 }}>
            {translate("add_new_sequencing_rule")}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: "12px" }}
          >
            {translate("add_new_sequence_rule_description")}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: 2,
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <Box sx={{ flex: 1, minWidth: 220 }}>
            <RHFTextField
              name="series"
              label={translate("series")}
              variant="outlined"
              size="small"
              fullWidth
              disabled={isLoading || isWriteDisabled}
            />
          </Box>

          <Box sx={{ flex: 1, minWidth: 220 }}>
            <RHFTextField
              name="initialSequenceNumber"
              label={translate("starting_number")}
              variant="outlined"
              type="number"
              size="small"
              fullWidth
              disabled={isLoading || isWriteDisabled}
            />
          </Box>
        </Box>
        <Stack
          direction="row"
          spacing={2}
          sx={{ justifyContent: "flex-end", mt: 1 }}
        >
          <LockedButton
            variant="contained"
            size="small"
            type="submit"
            buttonText={translate("add_new_rule")}
            locked={isWriteDisabled}
            loading={isLoading}
          />
        </Stack>
      </Card>
    </form>
  );
};
